import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "NaNoWriMo day3, when nothing happens",
  "description": "",
  "published": "2009-11-03T00:00:00.000Z",
  "redirect_from": ["/blog/nanowrimo-day3-when-nothing-happens/swizec/803"],
  "categories": "life, NaNoWriMo, Stack Overflow, Uncategorized, Writing",
  "hero": "./img/3204-2815403363_90e82d6f88_m.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/27164277@N00/2815403363"
          }}><figure parentName="a" {...{
              "className": "gatsby-resp-image-figure",
              "style": {
                "textAlign": "center",
                "fontStyle": "italic"
              }
            }}>{`
    `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "240px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "74.88789237668162%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M282%2027c-9%202-25%209-25%2011l-2%201-1%203c1%202%200%203-1%201h-2c-2%201-2%202-1%203%202%202%200%203-2%201-3-1-7%203-6%206%201%202%204%203%204%201l1-2%201%202c0%203%202%202%203-1s4-7%205-6l5-1c3-1%204-2%204-4l-1-2-1-1c1-1%205%201%205%203%200%203%202%202%203%200s1-3%204-2l3-1%202-1h7l9-1%206-2%202-1%202-1c3-2%208-2%2010%200l3%201c1-1%203%200%204%201l3%201%203%202c2%202%202%202%200%202l1%201%202%203%202%204%202%201%206%204%202%204c1%204%205%206%207%203%202-1%202-1%203%201%204%204%207%2014%205%2014l-1-1-1-2-1-3c0-3-2-5-3-3v4l3%206c0%203%201%204%202%204%202%200%202%200%201%201-2%200-3%206-1%206v15l-1%203c-1%203-1%203%201%204l-1%202v20l-1%203-1%202c2%200%202%201%201%205l-3%203-1%204-1%204-4%204-3%204h-1v1c2%200%201%204-1%205l1%201c1%201%201%201-1%201s-2%201-2%205c0%203%200%204-2%204s-5%203-5%205l-2%202c-3%202-3%202-3%200l-1%201c-1%202-2%202-4%202-4-1-5%203-3%205v3c-2%200-3%200-3%202%200%203-4%206-6%204s-4-1-4%201l-1%202h-3c-1%202-2%201-3-1s-1-2-3%201l-4%204-4%201h-3c-1%202-3%202-9%201h-7c-2%200-8-2-8-4l-2-1c-1%201-2%200-3-1l-4-2c-3%200-6-2-6-4%200-1%201-2%203-1%202%202%203%200%201-1-1-1-2-2-3-1-2%200-8-3-8-5l-3-3-3-4-2-3c-2-2-3-4-1-4l1-1h-2c-2%201-3-2-3-7l-1-4-2-2-2-3v-3c2-1%202-2%201-2l-1-9-1-9%201-28%202-3%201-1c-2%200-2-1-2-10l2-11v-4c0-3%200-3-1-1v-1c0-5-1-3-5%205-4%2010-9%2025-11%2035-2%2012-2%2012-4%205-5-13-15-32-18-32l-2-1c0-2-2-1-3%202-2%204-2%206%202%2010v11l1%208%202%208v11l-1%205-1%203-1%203c-2%201-2%202-1%203v4l-2%202-1%201-1%201c1%202-2%204-4%203-1%200-2%201-4%206l-2%204c-1-4-5%200-5%206%200%204%200%204-3%204l-4-1-2-1h-2c-1-1-1-1%200%200%200%202-1%202-3%202-3%200-2%202%201%203l2%202-4%201c-4-1-6%200-3%201%201%201%201%201-1%201l-3%201h-3c-2-1-4-2-5-1-3%200-4-1-2-3l-1-2-1%202c0%202%200%202-1%201-2-3-3-2-3%200l-3%202-5%202c-1%202-2%202-5%200-3-1-5-2-6-1l-2-1%203-1c2-1%203-1%202-2-2%200-1-3%201-4l2-3c0-2%200-2%201-1h4l2-2%201-3%201-3-2%201-2%201-1%202-2%201h-2l-4%203c-5%202-5%202-14%201l-3-2-3-1s-2-1-2-3c-2-2-2-3-4-2l-2-1h-2c-4%202-8%200-8-2l1-2%201%202%201%201c2-2%201-4-1-4s-2%200%200-3l1-4-2%202c-2%204-2%204-5%200l-4-3c-2%200-5-8-4-10%201-1%200-2-2-3-4-1-5-3-2-3l2-1%201-2%201-1c0-2-5-1-7%201l-2%201c-2%200-1-2%201-4v-2l-1-4-1-4-2-1%201-1c2%201%204-1%204-4v-2l1-4c0-3%201-4%204-7l3-4%202-2c2-1%202-1%201-3V89c2-3%202-3%202-1l1-1%203-2c2%200%203-2%201-4-1%200-1-1%201-1l2-3c0-2%201-3%202-3%202%200%203-2%202-4l2-3c2-2%202-2%202%202%200%202%200%203%201%202%201-5%202-7%205-7l2-1%202-1c2%200%204-2%204-4l1-2%201-2h-2l-4%201-4%201-8%202-9%203-6%202c-7%202-21%2020-27%2036-7%2016-8%2022-7%2046%200%2023%201%2031%208%2050a186%20186%200%200028%2053l5%207c8%2010%2022%2023%2030%2026%2014%207%2020%208%2033%208%2032%200%2059-24%2071-64l7-35a408%20408%200%200033%2066%2090%2090%200%200028%2025c5%204%2029%209%2039%208a68%2068%200%200025-7l3-2%206-4a164%20164%200%200020-22l3-6a177%20177%200%200016-52%20164%20164%200%2000-2-81l-1-3-1-3c0-4-6-20-11-29a113%20113%200%2000-33-40c-2-2-13-8-20-10-9-3-26-5-34-3M122%2047l-3%201-3%201-4%201c-5%200-16%203-13%204h4l7-1c3%201%205%200%207-1h11l4%201%204-2%206%201h6l-3-2-5-2-4-1h-14m275%20207l-2%202-3%203-7%207-6%204-4%202-3%202-4%203-5%201a97%2097%200%2001-9%205l-7%201-5%202h-6l-3%202c-2%203-2%203-11%203l-11%202-6%201c-2%200-3%200-2%201%202%202-9%203-22%203l-23%201%2066%201h77v-19c0-25-1-32-4-27M1%20279v21h72c43%200%2072%200%2071-1l-20-3-12-2-13-2-16-3h-6l-8-1-8-2-9-2-10-2-5-2-2-1-1-1-2-1-4-1-4-2c0-2-4-5-7-6l-5-2-3-2-1-2-2-2-3-1c-2-1-2%200-2%2020\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                    "srcSet": ["/static/c04ac496844bbd4ac42e037c30a73e93/ca0a1/3204-2815403363_90e82d6f88_m.webp 223w", "/static/c04ac496844bbd4ac42e037c30a73e93/8ac56/3204-2815403363_90e82d6f88_m.webp 240w"],
                    "sizes": "(max-width: 240px) 100vw, 240px",
                    "type": "image/webp"
                  }}></source>{`
          `}<source parentName="picture" {...{
                    "srcSet": ["/static/c04ac496844bbd4ac42e037c30a73e93/853b2/3204-2815403363_90e82d6f88_m.jpg 223w", "/static/c04ac496844bbd4ac42e037c30a73e93/09b79/3204-2815403363_90e82d6f88_m.jpg 240w"],
                    "sizes": "(max-width: 240px) 100vw, 240px",
                    "type": "image/jpeg"
                  }}></source>{`
          `}<img parentName="picture" {...{
                    "className": "gatsby-resp-image-image",
                    "src": "/static/c04ac496844bbd4ac42e037c30a73e93/09b79/3204-2815403363_90e82d6f88_m.jpg",
                    "alt": "2008SEP011118",
                    "title": "2008SEP011118",
                    "loading": "lazy",
                    "style": {
                      "width": "100%",
                      "height": "100%",
                      "margin": "0",
                      "verticalAlign": "middle",
                      "position": "absolute",
                      "top": "0",
                      "left": "0"
                    }
                  }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
                "className": "gatsby-resp-image-figcaption"
              }}>{`2008SEP011118`}</figcaption>{`
  `}</figure></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/27164277@N00/2815403363"
          }}>{`bootload`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`It is now 04:42 and it's about time I head off to bed since Wednesdays do in fact still exist, I don't know whose bright idea this was, but they had it and now we have it.`}</p>
    <p>{`Yesterday I complained about falling asleep too early to do any serious amount of writing. Today however the problem is quite the opposite - I don't seem to be sleepy at all and yet, I have written even less than yesterday. The inspiration just wasn't there and yes, I know, `}<a parentName="p" {...{
        "href": "http://www.nanowrimo.org/",
        "title": "NaNoWriMo"
      }}>{`NaNoWriMo`}</a>{` is all about making us write even when inspiration is low and just fucking get on with it mister writer! WRITE god damn it!`}</p>
    <p>{`Well I didn't. But I have read a whole bunch of interesting questions over at `}<a parentName="p" {...{
        "href": "http://www.stackoverflow.com/",
        "title": "Stack Overflow"
      }}>{`Stack Overflow`}</a>{` and answered some of them (if you haven't read on twitter, I've decided to start paying-it-forward by answering at least one question a day). I also have created a spankingly fresh `}<a parentName="p" {...{
        "href": "http://www.linkedin.com/in/swizec"
      }}>{`LinkedIn account`}</a>{`.`}</p>
    <p>{`If nothing extraordinary like me getting an inspiration in the moment after head-hits-pillow and brain-shuts-off happens this lapse in concentration makes me roughly 4000 words behind official schedule. `}{`\\`}{`o/`}</p>
    <p>{`Who knows, tomorrow I might actually do something about that.`}</p>
    <p>{`PS: I'm delaying this being posted to catch the early crowd on twitter, yes, I'm that lame.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/a7fa5c65-e73c-4a21-baf4-3982c53927ba/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=a7fa5c65-e73c-4a21-baf4-3982c53927ba",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      